export const PRODUCT_FEATURE_KEY = 'product';
